import AboutApoloan from '@/components/landing/about/AboutApoloan'
import Footer from '@/components/landing/footer/Footer'
import Header from '@/components/landing/header/Header'
import HeroSection from '@/components/landing/hero-section/HeroSection'
import RequiredDocs from '@/components/landing/required-docs/RequiredDocs'
import FaqSection from '@/components/sections/faq/FaqSection'
import RegStepsSection from '@/components/sections/reg-steps/RegStepsSection'
import TestimonialSections from '@/components/sections/testimonial/TestimonialSections'
import { Fragment } from 'react/jsx-runtime'
function Home() {
  return (
    <Fragment>
      <Header />
      <main className="space-y-12">
        <div>
          <HeroSection />
          {/* <SectionContainer>
            <Features />
          </SectionContainer> */}
        </div>
        {/* <SectionContainer
          title="نظرات کاربران دیجی شهر"
          sectionClass="desktop:pb-10 !mt-20"
        >
          <TestimonialSections />
        </SectionContainer> */}
        {/* <SectionContainer
          title="مراحل شروع همکاری با دیجی‌شهر"
          sectionClass="bg-loan_step-radial-gradient-1 tablet:bg-loan_step-radial-gradient-2 py-20 bg-gray-50 !mt-0"
        >
        </SectionContainer>
        <SectionContainer
          title="مدارک لازم برای ثبت‌نام فروشندگان"
          sectionClass="bg-gray-50 !mt-0"
        >
          <RequiredDocs />
        </SectionContainer>
        <SectionContainer
          sectionClass="bg-gray-50 pb-10 pt-16 !mt-0"
          title="سوالات متداول"
        >
          <FaqSection />
        </SectionContainer> */}

          <RegStepsSection />
    
          <RequiredDocs />

          <FaqSection />
      </main>
      <AboutApoloan />
      <Footer />
    </Fragment>
  )
}

export default Home
